import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchKids, getFilteredKids } from "./Kids-list.ducks";
import { closeSnackBar, openSnackBar } from "../../../reducers";
import { Header, Footer, MySnackBars } from "../../../components";
import {
  ErrorSnackbar,
  SuccessSnackbar,
} from "../../../components/IntegratedSnackbars";
import Compte from "../../../components/compte/Compte";
import _ from "lodash";
import FicheEnfant from "./fiche-enfant/FicheEnfant";
import { getJournee } from "./fiche-enfant/les-tabs-ducks/Journee.ducks";
import srcAddWhite from "../../../styles/img/add-white.svg";
import GestionCreche from "./creche/GestionCreche";
import Evenements from "./evenements/Evenements";
import srcImgBaby from "../../../styles/img/icon-baby.svg";
import Communaute from "./communaute/Communaute";
import Staff from "./staff/Staff";
import Menus from "./menus/Menus";
import { fetchAgent } from "../../../components/compte/compte.ducks";
import Kids from "./Kids.jsx";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { Service } from "../../service/service";
import { API } from "../../../const";
import moment from "moment";



const ListDisplay2 = React.lazy(() => import("./list-display"));

const AddWhite = () => (
  <object
    data={srcAddWhite}
    type="image/svg+xml"
    style={{ pointerEvents: "none", width: "12px", height: "12px" }}
    className="img-fluid"
  />
);
const IconBaby = () => (
  <object
    data={srcImgBaby}
    style={{ width: "70px", pointerEvents: "none", cursor: "pointer" }}
    type="image/svg+xml"
    className="img-fluid"
  />
);

var divStyleImg = {
  width: "12px",
};

class AllRoutes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listNotifications: [],
    };
    this.toggleSimple = this.toggleSimple.bind(this);
    this.handleCloseError = this.handleCloseError.bind(this);
    this.handleCloseSuccess = this.handleCloseSuccess.bind(this);
  }
  componentDidMount() {
    let tok = localStorage.getItem("token");
    const response = Service.get(`${API}api/creche/notifications`, {
      headers: { Authorization: `Bearer ${tok}` },
    });
    response.then((res) => {
      let sortedNotificationsSidebar = _.isEmpty(res.data.notifications)
        ? []
        : res.data.notifications.sort((a, b) =>
          moment(b.dateTime).diff(a.dateTime)
        );
      this.setState({
        listNotifications: sortedNotificationsSidebar,
      });
    });
  }
  handleCloseError() {
    this.props.closeSnackBar("errorMsg");
    this.setState({
      showAlertSnackbars: false,
    });
  }

  handleCloseSuccess() {
    this.props.closeSnackBar("successMsg");
    this.setState({
      showAlertSnackbars: false,
    });
  }

  toggleSimple() {
    this.setState({
      showAlertSnackbars: true,
    });
  }

  render() {
    const { match } = this.props;
    const displayHide = { display: "none" };
    const displayShow = { display: "block" };
    return (
      <main className="main-wrapper">
        {this.props.successMsg.status ? (
          <SuccessSnackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            open={this.props.successMsg.status}
            autoHideDuration={2000}
            onClose={this.handleCloseSuccess}
            onEntering={this.toggleSimple}
            variant="success"
            display={displayHide}
            message={this.props.successMsg.message}
          />
        ) : (
          ""
        )}
        {this.props.errorMsg.status ? (
          <ErrorSnackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            open={this.props.errorMsg.status}
            onClose={this.handleCloseError}
            autoHideDuration={5000}
            variant="error"
            display={displayShow}
            message={this.props.errorMsg.message}
          />
        ) : (
          ""
        )}
        <Header
          title="Page d'acceuil"
          compteData={this.props.compte}
          listNotifications={this.state.listNotifications}
        />
        <Switch>
          <Route exact path={`/`} render={(props) => <Kids {...props} />} />
          <Route path={`/enfants`} render={(props) => <Kids {...props} />} />

          <Route
            path={`/creche/archives/:id`}
            render={(props) => <FicheEnfant {...props} />}
          />
          <Route
            path={`/creche`}
            render={(props) => <GestionCreche {...props} />}
          />
          <Route
            path={`/evenements`}
            render={(props) => <Evenements {...props} />}
          />
          <Route path={`/menus`} render={(props) => <Menus {...props} />} />
          <Route path={`/staff`} render={(props) => <Staff {...props} />} />


          <Route path={`/compte`} render={(props) => <Compte {...props} />} />
          <Route
            path={`/communaute`}
            render={(props) => (
              <Communaute compteData={this.props.compte} {...props} />
            )}
          />
          <Route
            path={`/enfant/:id`}
            render={(props) => <FicheEnfant {...props} />}
          />

          <Redirect to="/enfants" />
        </Switch>

        <Footer match={match} />
      </main>
    );
  }
}

const mapStateToProps = ({ errorMsg, successMsg, compte }) => ({
  errorMsg,
  successMsg,
  compte,
});

const mapDispatchToProps = {
  getJournee,
  getFilteredKids,
  fetchKids,
  closeSnackBar,
  openSnackBar,
  fetchAgent,
};

const withStore = connect(mapStateToProps, mapDispatchToProps);

export default withStore(AllRoutes);
